import React, { useState, useEffect } from "react";
import "./AIModal.scss";
import { ReactComponent as AI_icon } from "../../../assets/svg/AI-icon.svg";
//import { getAccessToken } from "../../../../src/actions/utils";
import Dimmer from "semantic-ui-react/dist/es/modules/Dimmer";
import Loader from "semantic-ui-react/dist/es/elements/Loader";
import { fetchQuestionData, fetchSearchData } from "./AIModalAction";

const AIModal = ({ isOpen, onClose }) => {
    const [selectedQuestion, setSelectedQuestion] = useState(null);
    const [searchTerm, setSearchTerm] = useState("");
    const [searchResult, setSearchResult] = useState(null);
    const [loading, setLoading] = useState(false);

    const questions = [
        { id: 1, text: "How to authenticate the social tokens ?" },
        { id: 2, text: "How to create a query ?" },
        { id: 3, text: "How to reset the password ?" },
        { id: 4, text: "How to add a new user ?" },
    ];

    const handleQuestionClick = async (questionText) => {
        setLoading(true);
        const responseData = await fetchQuestionData(questionText);
        setSelectedQuestion(responseData?.data?.data);
        setSearchResult(null);
        setSearchTerm(questionText);
        setLoading(false);
    };

    const handleSearch = async () => {
        setLoading(true);
        const responseData = await fetchSearchData(searchTerm);
        setSearchResult(responseData?.data?.data);
        setSelectedQuestion(null);
        setLoading(false);
    };

    // const handleCloseResponseBox = () => {
    //     setSelectedQuestion(null);
    //     setSearchResult(null);
    // };

    const formatResponse = (text) => {
        const urlRegex = /(https?:\/\/[^\s]+)/g;

        if (urlRegex.test(text)) text = text.replace(urlRegex, (url) => `<a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`);
        return text.replace(/\n/g, "<br>");
    };

    const handleClearSearch = () => {
        setSearchTerm("");
        setSelectedQuestion(null);
        setSearchResult(null);
    };

    useEffect(() => {
        if (!isOpen) {
            setSearchTerm("");
            setSelectedQuestion(null);
            setSearchResult(null);
        }
    }, [isOpen]);

    return isOpen ? (
        <div className="ai-modal">
            <div className="ai-modal-header">
                <div className="ai-icon-wrapper">
                    <AI_icon className="ai-icon" />
                </div>
                <h2>Support Genie</h2>
                <button className="close-button" onClick={onClose}>
                    &times;
                </button>
            </div>
            <div className="ai-modal-body">
                <p>Radarr AI enables you to create a best-in-class customer experience throughout your support lifecycle</p>
                <div className="search-box">
                    <input type="text" placeholder="Search..." value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} />
                    {searchTerm && (
                        <button className="clear-search" onClick={handleClearSearch}>
                            &times;
                        </button>
                    )}
                    <button className="search-button" onClick={handleSearch}>
                        Search
                    </button>
                </div>
                {loading && (
                    <Dimmer active style={{ background: "transparent", border: "none" }}>
                        <Loader style={{ marginTop: "70px" }}>Loading</Loader>
                    </Dimmer>
                )}
                {(searchResult || selectedQuestion) && (
                    <div className="response-box">
                        {/* <div className="response-header">
                                <button className="close-response" onClick={handleCloseResponseBox}>
                                    &times;
                                </button>
                            </div> */}
                        <h3>Result:</h3>
                        <p dangerouslySetInnerHTML={{ __html: formatResponse(searchResult || selectedQuestion) }} />
                    </div>
                )}
                {!searchResult && !selectedQuestion && (
                    <div className="question-boxes">
                        <div className="question-box-group">
                            {questions.slice(0, 2).map((question) => (
                                <div key={question.id} className="question-box" onClick={() => handleQuestionClick(question.text)}>
                                    {question.text}
                                </div>
                            ))}
                        </div>
                        <div className="question-box-group">
                            {questions.slice(2).map((question) => {
                                return (
                                    <div key={question.id} className="question-box" onClick={() => handleQuestionClick(question.text)}>
                                        {question.text}
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                )}
            </div>
        </div>
    ) : (
        <div />
    );
};

export default AIModal;
